<template>
  <div class="ls-box">
    <h5 class="ls-title-5 ls-md-margin-bottom" :class="{ 'ls-color-theme' : $parent.$data.forms.login }"><i class="fa fa-user-o" aria-hidden="true"></i> {{ $t('subscribe.titles.identify') }}</h5>
    <form class="ls-form" @submit.prevent="validateBeforeSubmit">
      <fieldset>
        <div class="row">
          <div class="col-md-8 col-xs-12">
            <MaterialInput
              disabled
              type="email"
              v-model="$parent.$data.email"
              ico="fa fa-envelope-o">
                {{ $t('subscribe.attributes.email') }}
                <i class="fa fa-check" slot="ico-check" aria-hidden="true"></i>
            </MaterialInput>
          </div>
          <div class="col-md-4 ls-lg-margin-bottom ls-display-inline-block ls-display-none-xs">
            <p><a href="javascript:void(0)" @click="$parent.backToEmailForm">{{ $t('subscribe.attributes.choose_another_email') }}</a></p>
          </div>
        </div>
        <div class="ls-clearfix"></div>
        <div class="row">
          <div class="col-md-8">
            <MaterialInput
              type="password"
              focused="true"
              ico="fa fa-lock"
              label="Password"
              v-model="password"
              v-validate="'required|min:6'"
              :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.password')) }"
              :data-vv-name="$t('subscribe.attributes.password')">
                {{ $t('subscribe.attributes.password') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.password'))">{{ errors.first($t('subscribe.attributes.password')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.password')) && password.length" aria-hidden="true"></i>
            </MaterialInput>
          </div>

        </div>
      </fieldset>
      <button class="btn btn-act next btn-fixed-bottom-xs">{{ $t('application.button.login') }}</button>
      <button class="btn prev btn-fixed-bottom-xs ls-display-none-sm ls-display-none-md ls-display-none-lg" @click="$parent.backToEmailForm"><span class="ls-ico-chevron-left"></span> {{ $t('subscribe.attributes.choose_another_email') }}</button>
    </form>
  </div>
</template>
<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import MaterialInput from '../../../components/shareds/MaterialInput.vue'

  export default {
    name: 'login-form',
    components: { MaterialInput },
    data () {
      return {
        password: ''
      }
    },
    computed: {
      ...mapGetters(['cust'])
    },
    methods: {
      ...mapActions(['attemptCustomerLogin', 'retrieveCustomerData']),
      ...mapMutations(['clearFlash', 'addFlash']),
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validateAll().then(this.afterValidate)
      },
      afterValidate (result) {
        if (result) {
          this.doLogin()
        } else {
          this.$loader.hide()
        }
      },
      doLogin () {
        const customer = { email: this.$parent.$data.email, password: this.password }

        this.clearFlash()
        this.attemptCustomerLogin(customer).then(this.afterLogin)
      },
      afterLogin (response) {
        if (response && response.status === 200) {
          this.retrieveCustomerData(response.data.customer.id).then(this.afterRetrieveCustomerData)
        } else {
          this.password = ''
          this.$loader.hide()
        }
      },
      afterRetrieveCustomerData (response) {
        if (response && response.status === 200) {
          this.addFlash({ message: this.$t('subscribe.messages.data_loaded_successfully'), type: 'ls-alert-success' })
          setTimeout(this.clearFlash, 2500)
          this.$parent.setCustomerCheckout(this.cust)
          this.$parent.$data.forms.login = false
          this.$parent.$data.forms.signup = true
          this.$parent.$data.forms.submitted.signup = true
          this.$parent.$data.forms.address = true
          this.$parent.$data.forms.payment = true
        }
        this.$loader.hide()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoginForm.vue?57e79c54